var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGuidedSellingRestart({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "16px",
    viewBox: "0 0 17 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "noun_restart_3652915") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Guided-Selling",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "MBL-GS-Zielgruppe_v3",
    transform: "translate(-19.000000, -600.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_restart_3652915",
    transform: "translate(19.000000, 600.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4096875,3.1190625 C13.676866,0.751203572 10.7308192,-0.400669363 7.85145897,0.163875629 C4.97209876,0.728420621 2.67913606,2.90748584 1.96875,5.754375 L1.0603125,4.0134375 C0.966362816,3.83558622 0.784667199,3.72136642 0.583668631,3.7138036 C0.382670063,3.70624077 0.192905008,3.80648389 0.0858561267,3.97677235 C-0.0211927543,4.1470608 -0.0292621892,4.36152372 0.0646875,4.539375 L1.8140625,7.8553125 L1.8140625,7.8721875 C1.83406204,7.90645299 1.85763071,7.93850639 1.884375,7.9678125 L1.8984375,7.9846875 C1.92979802,8.01587134 1.96472675,8.04324791 2.0025,8.06625 L2.0334375,8.083125 C2.06403582,8.09915845 2.09604606,8.11233913 2.1290625,8.1225 L2.165625,8.1225 C2.20886319,8.13334293 2.253237,8.13900767 2.2978125,8.139375 L2.2978125,8.139375 C2.33614851,8.14332525 2.37478899,8.14332525 2.413125,8.139375 L2.446875,8.139375 C2.47682369,8.13056388 2.50598689,8.1192749 2.5340625,8.105625 L2.5509375,8.105625 L5.866875,6.35625 C6.04774071,6.26682196 6.16715823,6.08769633 6.18014413,5.88634801 C6.19313002,5.68499969 6.09771144,5.49201828 5.92983162,5.38009801 C5.76195181,5.26817773 5.54711571,5.25432195 5.36625,5.34375 L2.9475,6.620625 C3.38296845,3.76465232 5.66764361,1.5485007 8.53554926,1.20017632 C11.4034549,0.851851946 14.152209,2.45666334 15.2586815,5.12535803 C16.365154,7.79405271 15.5583575,10.8730376 13.2853512,12.6561964 C11.0123449,14.4393551 7.82981342,14.4899722 5.50125,12.78 C5.33988555,12.6535153 5.12248178,12.6248474 4.93384548,12.7051793 C4.74520918,12.7855112 4.61522264,12.9621174 4.59459215,13.1661057 C4.57396166,13.3700941 4.66595535,13.5691504 4.8346875,13.685625 C7.84392551,15.8934497 12.013843,15.5758755 14.654025,12.9378 C17.294207,10.2997245 17.6151096,6.13006182 15.4096875,3.1190625 Z",
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuidedSellingRestart);
export default __webpack_public_path__ + "static/media/guided-selling-restart.ff9749d55b9407463de3642ab91599a0.svg";
export { ForwardRef as ReactComponent };